module.exports = __webpack_public_path__ + "static/media/soup.a6cc84ec.png";